import {http} from "@/services/index";
import objectUtil from "@/utils/objectUtil";

class ApiService {

    get(entity, params = {}) {
        const queryParams = objectUtil.toQueryString(params).toString();
        return http.get(`/${entity}?${queryParams}`);
    }

    getOne(entity, id, params = {}) {
        const queryParams = objectUtil.toQueryString(params).toString();
        return http.get(`/${entity}/${id}?${queryParams}`);
    }

    create(entity, data, config = {}) {
        return http.post(`/${entity}`,data, config);
    }

    update(entity, id, data, config = {}) {
        return http.put(`/${entity}/${id}`, data, config);
    }

    delete(entity, id) {
        return http.delete(`/${entity}/${id}`);
    }

    rawPost(url, data, config = {}) {
        return http.post(url, data, config)
    }

    rawPut(url, data, config = {}) {
        return http.put(url, data, config)
    }

    rawGet(url, params = {}) {
        const queryParams = objectUtil.toQueryString(params).toString();
        return http.get(`${url}?${queryParams}`)
    }
}

export default ApiService;
